import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div data-testid="terms-page" className="max-w-3xl mx-auto py-10 space-y-8 animate-fade-in">
      <div>
        <Link to="/" className="text-zinc-500 text-sm hover:text-white transition-colors">← Back to StagePass</Link>
        <h1 className="text-3xl font-black text-white mt-4 mb-2">Terms of Service</h1>
        <p className="text-zinc-500 text-sm">Last updated: {new Date().toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" })}</p>
      </div>

      {[
        {
          title: "1. Acceptance of Terms",
          body: "By accessing or using the StagePass platform ('Service'), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use the Service. We may update these terms from time to time and will notify you of significant changes.",
        },
        {
          title: "2. Eligibility",
          body: "You must be at least 13 years old to use StagePass. By using the Service, you represent that you meet this age requirement. If you are under 18, you represent that you have your parent or guardian's permission to use the Service.",
        },
        {
          title: "3. Creator Accounts",
          body: "Creator accounts are subject to admin approval. By applying for a creator account, you agree to provide accurate information about yourself and your content. Creator status may be revoked if you violate these terms or our community guidelines. Creators are responsible for all content they upload and must have the necessary rights to any audio, video, or images they publish.",
        },
        {
          title: "4. Content Guidelines",
          body: "You agree not to upload content that: infringes copyright or other intellectual property rights, contains explicit adult content unless designated as such and age-gated, harasses, abuses, or threatens others, violates any applicable laws, or impersonates any person or entity. StagePass reserves the right to remove content that violates these guidelines without notice.",
        },
        {
          title: "5. Music and Copyright Compliance",
          body: "You must have all necessary rights and licenses for music you upload. This includes mechanical licenses, performance rights, and sync licenses where applicable. StagePass is not responsible for copyright claims related to music uploaded by creators. Repeated copyright violations may result in account termination.",
        },
        {
          title: "6. Radio and Broadcasting",
          body: "Radio stations on StagePass are subject to additional review and approval. Station owners are responsible for ensuring their broadcasts comply with applicable broadcasting regulations. Auto-DJ features using uploaded content are limited to content the creator has rights to broadcast.",
        },
        {
          title: "7. Termination",
          body: "We reserve the right to suspend or terminate your account at any time for violations of these terms, fraudulent activity, or behavior that harms the StagePass community or brand. You may terminate your account at any time by contacting us.",
        },
        {
          title: "8. Disclaimers",
          body: "The Service is provided 'as is' without warranties of any kind. StagePass is not responsible for content uploaded by users. We do not guarantee uninterrupted access to the Service.",
        },
        {
          title: "9. Contact",
          body: "Questions about these Terms should be directed to legal@stagepassaccess.com.",
        },
      ].map((section) => (
        <section key={section.title} className="bg-[#111] border border-white/5 rounded-2xl p-5">
          <h2 className="text-white font-bold text-base mb-3">{section.title}</h2>
          <p className="text-zinc-400 text-sm leading-relaxed">{section.body}</p>
        </section>
      ))}
    </div>
  );
}
